module.exports = __webpack_public_path__ + "img/keyboard_C.96348ddc.png";